// safetyFormLists/safetyAuditLists/actions.js

import { getUserSafetyAuditChecklistFormList } from "../../../api/SafetyFormApi";
import { safetyAuditListInitialState } from "./safetyFormListsSafetyAuditListState";
import { makeFiltersActions } from "../../shared/filters/filtersActions";

export const makeSafetyAuditListActions = (set, get) => ({
  setSafetyAuditListPage: ({ currentPage, pageSize }) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: {
          ...s.safetyFormLists.safetyAuditList,
          currentPage,
          pageSize,
        },
      },
    })),

  setSafetyAuditListPageSize: (pageSize) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: {
          ...s.safetyFormLists.safetyAuditList,
          pageSize,
          currentPage: 1,
        },
      },
    })),

  setSelectedSafetyAudit: (safetyAudit) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: {
          ...s.safetyFormLists.safetyAuditList,
          selectedSafetyAudit: safetyAudit,
        },
      },
    })),

  deleteSafetyAuditLocal: (id) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: {
          ...s.safetyFormLists.safetyAuditList,
          items: s.safetyFormLists.safetyAuditList.items.filter(
            (n) => n.id !== id
          ),
        },
      },
    })),

  upsertSafetyAuditLocal: (safetyAudit) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: {
          ...s.safetyFormLists.safetyAuditList,
          items: [...s.safetyFormLists.safetyAuditList.items, safetyAudit],
        },
      },
    })),

  resetSafetyAuditList: () =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: safetyAuditListInitialState,
      },
    })),

  ...makeFiltersActions(set, get, "SafetyAuditListDrafts"),

  fetchSafetyAuditListDraftsPage: async (employeeId, externalFilters = null) => {
    // Using only state parameters since they contain the current pagination and filter values
    const {
      safetyFormLists: {
        safetyAuditList: { currentPage, pageSize, filters },
      },
    } = get();
    const effectiveFilters = externalFilters || filters;

    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: {
          ...s.safetyFormLists.safetyAuditList,
          loading: true,
          error: null,
        },
      },
    }));

    try {
      const r = await getUserSafetyAuditChecklistFormList(
        employeeId,
        currentPage,
        pageSize,
        effectiveFilters
      );
      set((s) => ({
        safetyFormLists: {
          ...s.safetyFormLists,
          safetyAuditList: {
            ...s.safetyFormLists.safetyAuditList,
            loading: false,
            items: r.data || [],
            totalCount: r.total_count,
          },
        },
      }));
    } catch (err) {
      console.error("Failed to fetch safety audit list drafts page:", err);
      set((s) => ({
        safetyFormLists: {
          ...s.safetyFormLists,
          safetyAuditList: {
            ...s.safetyFormLists.safetyAuditList,
            loading: false,
            error: err.message,
          },
        },
      }));
    }
  },

  upsertSafetyAuditDraftLocal: (row) =>
    set((s) => {
      const existingItems = s.safetyFormLists?.safetyAuditList?.items || [];
      const existingIndex = existingItems.findIndex(
        (item) => String(item.id) === String(row.id)
      );
      let newItems;
      let newTotalCount;
      if (existingIndex >= 0) {
        newItems = [...existingItems];
        newItems[existingIndex] = { ...newItems[existingIndex], ...row };
        newTotalCount = s.safetyFormLists.safetyAuditList.totalCount || 0;
      } else {
        newItems = [...existingItems, row];
        newTotalCount = (s.safetyFormLists.safetyAuditList.totalCount || 0) + 1;
      }
      return {
        safetyFormLists: {
          ...s.safetyFormLists,
          safetyAuditList: {
            ...s.safetyFormLists.safetyAuditList,
            items: newItems,
            totalCount: newTotalCount,
          },
        },
      };
    }),

  removeSafetyAuditDraftLocal: (id) =>
    set((s) => ({
      safetyFormLists: {
        ...s.safetyFormLists,
        safetyAuditList: {
          ...s.safetyFormLists.safetyAuditList,
          items: s.safetyFormLists.safetyAuditList.items.filter(
            (n) => n.id !== id
          ),
          totalCount: s.safetyFormLists.safetyAuditList.totalCount - 1,
        },
      },
    })),
});
